import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Disc3, ArrowUpRight, Clock } from 'lucide-react';

/**
 * Row rendered under an event's lineup list when the event has an active DJ
 * open call. Same row format as artists but with a dashed gold border.
 */
export default function OpenCallSlotTile({ call, delay = 0 }) {
  if (!call) return null;
  const slots = Array.isArray(call.time_slots) ? call.time_slots : [];
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay }}
    >
      <Link
        to="/portal-dj"
        className="group relative flex items-center gap-3.5 px-4 sm:px-5 py-3 rounded-2xl border-2 border-dashed border-[#D4AF37]/50 hover:border-[#D4AF37] bg-gradient-to-r from-[#D4AF37]/10 via-[#0d0b06] to-black transition-colors overflow-hidden"
        data-testid={`lineup-open-slot-${call.id}`}
      >
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_15%_50%,rgba(212,175,55,0.16),transparent_60%)] pointer-events-none" />

        {/* Spinning vinyl (mirrors artist avatar) */}
        <div className="relative w-11 h-11 rounded-full border border-[#D4AF37]/40 bg-black/40 flex items-center justify-center flex-shrink-0">
          <Disc3
            size={22}
            className="text-[#D4AF37] animate-[spin_6s_linear_infinite] group-hover:animate-[spin_1.5s_linear_infinite]"
            strokeWidth={1.5}
          />
          <span className="absolute -top-0.5 -right-0.5 flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D4AF37] opacity-60" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#D4AF37]" />
          </span>
        </div>

        <div className="flex-1 min-w-0 relative">
          <p className="text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37]">Slot abierto · ¿Sos DJ?</p>
          <p className="font-bold text-white text-sm sm:text-base leading-tight truncate mt-0.5" style={{ fontFamily: "'Unbounded', sans-serif" }}>
            {call.title || 'Convocatoria DJ'}
          </p>
          {slots.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {slots.map((s) => (
                <span
                  key={s.id}
                  className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-[#D4AF37]/35 bg-black/40 text-[10px] font-mono font-bold text-[#D4AF37]"
                >
                  <Clock size={9} />
                  {[s.start_time, s.end_time].filter(Boolean).join('–')}{s.label ? ` · ${s.label}` : ''}
                </span>
              ))}
            </div>
          )}
        </div>

        <span className="relative inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#D4AF37] text-black text-[10px] font-black uppercase tracking-widest whitespace-nowrap group-hover:gap-2 transition-all flex-shrink-0">
          Postulate <ArrowUpRight size={11} strokeWidth={3} />
        </span>
      </Link>
    </motion.div>
  );
}
